export const detailUrl = ({ id }) => {
  return ``;
};
